import ContentModalProvider from './ContentModalProvider'
import ContentEditModal from './ContentEditModal'
import { ContentItemObject, ContentType } from '../../ContentManagementProvider/Context'

export type ContentModalProps = {
  show: boolean
  onHide: () => void
  contentItem: ContentItemObject
  type?: ContentType
}

const ContentModal = (props: ContentModalProps) => {
  return (
    <ContentModalProvider {...props}>
      <ContentEditModal />
    </ContentModalProvider>
  )
}

export default ContentModal
